import { render } from "./picture_wrapper.vue?vue&type=template&id=2d204ae8&scoped=true"
import script from "./picture_wrapper.vue?vue&type=script&lang=js"
export * from "./picture_wrapper.vue?vue&type=script&lang=js"

import "./picture_wrapper.vue?vue&type=style&index=0&id=2d204ae8&scoped=true&lang=css"

import exportComponent from "D:\\Users\\User\\Documents\\_PROJECTS\\VUE.JS\\tulmash\\web_widgets\\calc_feeder\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d204ae8"]])

export default __exports__